export default {
    client: 'Annulé par client',
    dealer: 'Annulé par concessionnaire',
};
